import {NgModule} from '@angular/core';
import {ApolloModule, APOLLO_OPTIONS} from 'apollo-angular';
import { ApolloClientOptions, InMemoryCache, ApolloLink } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { setContext } from '@apollo/client/link/context';
import { User } from './models/user';
import { environment } from './../environments/environment';

function getUsername(): string {
  var user_name = localStorage.getItem('user');
  if (!user_name) {
    user_name = JSON.stringify({
      token: undefined
    });
  }
  return user_name;
}

const uri = environment.apiUrl + "/graphql"; // <-- add the URL of the GraphQL server here
//const uri = 'http://127.0.0.1:8000/api/graphql';
export function createApollo(httpLink: HttpLink): ApolloClientOptions<any> {
  const auth = setContext((operation, context) => {
    const user: User = JSON.parse(getUsername());

    if (user.token === undefined) {
      return {};
    } else {
      return {
        headers: {
          Authorization: `JWT ${user.token}`
        }
      };
    }
  });
  const link = ApolloLink.from([auth, httpLink.create({ uri })]);
  return {
    link: link,
    cache: new InMemoryCache(),
  };
}

@NgModule({
  exports: [ApolloModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
  ],
})
export class GraphQLModule {}
